export const Readme = () => {
    return (
        <div className="w-full h-full bg-white p-4 font-mono text-sm">
            <p>Welcome to the Windows 11 React Clone!</p>
            <p className="mt-2">This is a demonstration of a Windows 11-like interface built with React and Tailwind CSS.</p>
            <p className="mt-2">Features:</p>
            <ul className="list-disc ml-6 mt-1">
                <li>Draggable windows</li>
                <li>Start menu</li>
                <li>Desktop icons</li>
                <li>File Explorer</li>
            </ul>
        </div>
    );
};
